import json from "@/static/json/country_en.json";

export const countryCodes = [
  "DE",
  "PT",
  "DK",
  "LT",
  "LU",
  "HR",
  "LV",
  "UA",
  "HU",
  "MC",
  "MD",
  "ME",
  "YT",
  "IE",
  "US",
  "MK",
  "EE",
  "AD",
  "IM",
  "MT",
  "IS",
  "AL",
  "IT",
  "VA",
  "AM",
  "ES",
  "AT",
  "RE",
  "AX",
  "JE",
  "RO",
  "NL",
  "BA",
  "NO",
  "RS",
  "BE",
  "FI",
  "BG",
  "JP",
  "FO",
  "FR",
  "SE",
  "BV",
  "SI",
  "BY",
  "SJ",
  "SK",
  "SM",
  "GB",
  "CA",
  "GE",
  "GG",
  "GI",
  "CH",
  "GL",
  "GP",
  "GR",
  "CN",
  "XK",
  "CY",
  "CZ",
  "PL",
  "LI",
  "TR",
];

export const countries = json.data.countries;